import { getFromDictByCode, useDictStore } from "@/stores/dictStore";
import { IComponentConfig } from "@/app/@types/base-component";
import {
    CutsHolesTransomValueCode,
    DoubleFabricProducedDoorTypeCode,
    HandleTypeCode,
    LockTypeCode,
    MountedTransomPatchPSCValueCode,
    PatchesSetTypeCode,
    RollerSetTypeCode,
    SingleFabricProducedDoorTypeCode,
    TransomHardwareTypeCode,
    TransomPivotPatchPSPValueCode,
    UHolderTypeCode,
} from "@/app/constants/hardwares";
import { computed } from "vue";

export type ConfigBuilder = {
    structureCode(value: string): ConfigBuilder;
    valueNone(): ConfigBuilder;
    title(value: string): ConfigBuilder;
    qty(value: number): ConfigBuilder;
    build(): IComponentConfig;
    defaultQty(value: number): ConfigBuilder;
};

export const createRollerSetConfig = () => {
    return createHadwareConfig(RollerSetTypeCode);
};

export const createPatchesSetConfig = () => {
    return createHadwareConfig(PatchesSetTypeCode);
};

export const createUHolderConfig = () => {
    return createHadwareConfig(UHolderTypeCode);
};

export const createHandleConfig = () => {
    return createHadwareConfig(HandleTypeCode);
};

export const createLockConfig = () => {
    return createHadwareConfig(LockTypeCode).qty(1);
};

export const createSingleFabricProducedDoorConfig = () => {
    return createHadwareConfig(SingleFabricProducedDoorTypeCode);
};

export const createDoubleFabricProducedDoorConfig = () => {
    return createHadwareConfig(DoubleFabricProducedDoorTypeCode);
};

export const createTransomPivodPatchConfig = () => {
    return createHadwareConfig(TransomHardwareTypeCode)
        .structureCode(TransomPivotPatchPSPValueCode)
        .title("Sidelite Transom Pivot Patch PSP")
        .qty(1);
};

export const createMountedTransomPatchConfig = () => {
    return createHadwareConfig(TransomHardwareTypeCode)
        .structureCode(MountedTransomPatchPSCValueCode)
        .title("Sidelite Mounted Transom Patch PSC")
        .qty(1);
};

export const createTransomCutHoles = () => {
    return createHadwareConfig(TransomHardwareTypeCode)
        .structureCode(CutsHolesTransomValueCode)
        .title("CUTS (holes) for transom")
        .qty(4);
};

const createHadwareConfig = (hardwareTypeCode: string): ConfigBuilder => {
    const dictStore = useDictStore();

    const hardwares = computed(() =>
        dictStore.getHardwareValues(hardwareTypeCode),
    );

    const structureType =
        hardwares.value.length > 1 ? hardwares.value[1].code : "";

    const title = computed(
        () =>
            getFromDictByCode(
                dictStore.getHardwareTypes("door"),
                hardwareTypeCode,
            )?.title,
    );

    const config = {
        title: title.value,
        structureType,
        typeCode: hardwareTypeCode,
        qty: 1,
        defaultQty: 1,
    };

    const builder = {
        structureCode(value: string) {
            config.structureType = value;
            return builder;
        },
        valueNone() {
            // Подразумевается, что первый элемент в списке - это none
            const structureTypeNone =
                hardwares.value?.length > 1 ? hardwares.value[0].code : "";
            config.structureType = structureTypeNone;
            return builder;
        },
        defaultQty(value: number) {
            config.defaultQty = value;
            return builder;
        },
        qty(value: number) {
            config.qty = value;
            return builder;
        },
        title(value: string) {
            config.title = value;
            return builder;
        },
        build() {
            return config;
        },
    };

    return builder;
};
